import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createDomainApi, domainApiRelativePath } from './index';
import { createFakeGetResponder, createFakePutResponder, } from './../../../test-utils';
export var createDomainApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createDomainApi('', fakeHttp);
    var testKit = {
        whenGetDomainSettings: function (brandId) {
            return createFakeGetResponder(fakeHttp, "".concat(domainApiRelativePath).concat(brandId ? "?brandId=".concat(brandId) : ''));
        },
        whenLinkDomain: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(domainApiRelativePath, "/connect"))(dto);
        },
        whenUnlinkDomain: function (brandId) {
            return createFakePutResponder(fakeHttp, "".concat(domainApiRelativePath, "/disconnect"))({ brandId: brandId });
        },
        whenCheckDomainStatus: function (domain) {
            return createFakeGetResponder(fakeHttp, "".concat(domainApiRelativePath, "/check?domain=").concat(domain));
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map